// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root___j6dN","ranges":"BmiRanges_ranges__2yqEZ"};